[<RequireQualifiedAccess>]
module Client.Components.DropDownList

open Browser.Types
open Client.Domain
open Client.DomainTypes
open Client.DomainTypes.Msg
open Client.Infrastructure
open Fable.FontAwesome
open Fable.React
open Fable.React.Props
open Fulma

let createItem (icon: Fa.IconOption) (label: string) (onClick: MouseEvent -> unit) =
    Dropdown.Item.a [
        Dropdown.Item.Props [
            Clickable.onClickPreventDefault onClick |> OnClick
        ]
    ] [
        Icon.icon [ Icon.Size IsMedium ] [ Fa.i [ icon ] [] ]

        span [] [ str label ]
    ]

let createGoToRouteItem (dispatch: Msg -> unit) (icon: Fa.IconOption) (label: string) (route: Route) =
    let onClickMsg = Clickable.goToRouteMsg route
    let onClick = (fun _ -> onClickMsg |> dispatch)

    Dropdown.Item.a [
        Dropdown.Item.Props [
            Clickable.onClickPreventDefault onClick |> OnClick
            Href(Routing.routeToUrl route)
        ]
    ] [
        Icon.icon [ Icon.Size IsMedium ] [ Fa.i [ icon ] [] ]

        span [] [ str label ]
    ]

let createContextMenu (dropDownItems: ReactElement list) =
    Dropdown.dropdown [ Dropdown.IsHoverable; Dropdown.IsRight ] [
        Dropdown.trigger [] [
            Button.button [] [
                Icon.icon [ Icon.Size IsSmall ] [ Fa.i [ Fa.Solid.Cog ] [] ]
            ]
        ]
        Dropdown.menu [] [ Dropdown.content [] dropDownItems ]
    ]